import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mapTo, startWith, switchMap } from 'rxjs/operators';
import { AbstractSelfDiagnosisApiService } from '../../../core/services/abstract/abstract-self-diagnosis-api-service';
import * as actions from './actions';

@Injectable()
export class SelfDiagnosisEffects {
  private service = inject(AbstractSelfDiagnosisApiService);
  private actions$ = inject(Actions);

  getAllEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.GetAllRequest>(actions.ActionTypes.GET_ALL_REQUEST),
      switchMap(action =>
        this.service.getAll().pipe(
          map(response => (response.isSucceeded ? new actions.GetAllSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  getByIdEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.GetByIdRequest>(actions.ActionTypes.GET_BY_ID_REQUEST),
      switchMap(action =>
        this.service.getById(action.id).pipe(
          map(response => (response.isSucceeded ? new actions.GetByIdSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  updateEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.UpdateRequest>(actions.ActionTypes.UPDATE_REQUEST),
      switchMap(action =>
        this.service.update(action.entity).pipe(
          map(response => (response.isSucceeded ? new actions.UpdateSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  deleteEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.DeleteRequest>(actions.ActionTypes.DELETE_REQUEST),
      switchMap(action =>
        this.service.delete(action.id).pipe(
          map(response => (response.isSucceeded ? new actions.DeleteSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  uploadIconEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.UploadIconRequest>(actions.ActionTypes.UPLOAD_ICON_REQUEST),
      switchMap(action =>
        this.service.uploadIcon(action.entity, action.file).pipe(
          map(response => (response.isSucceeded ? new actions.UpdateSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );

  deleteIconEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.DeleteIconRequest>(actions.ActionTypes.DELETE_ICON_REQUEST),
      switchMap(action =>
        this.service.deleteIcon(action.entity).pipe(
          map(response => (response.isSucceeded ? new actions.UpdateSuccess(response.result) : new actions.Failure(response.errors[0]))),
          catchError(error => observableOf(new actions.Failure(error)))
        )
      )
    )
  );
}
